/* SAMSARA — interacciones propias (sin librerías) */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.sm-reveal:not(.sm-visible)');
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('sm-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('sm-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var imgs = document.querySelectorAll('[data-sm-parallax]');
    if (!imgs.length || reducido) return;
    var tick = false;
    function mover() {
      imgs.forEach(function (img) {
        var r = img.parentElement.getBoundingClientRect();
        var k = parseFloat(img.getAttribute('data-sm-parallax')) || 0.15;
        if (r.bottom > 0 && r.top < window.innerHeight) img.style.transform = 'translate3d(0,' + (-r.top * k) + 'px,0)';
      });
      tick = false;
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(mover); } }, { passive: true });
    mover();
  }

  function initCifras() {
    var els = document.querySelectorAll('[data-sm-contar]');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target, fin = parseFloat(el.getAttribute('data-sm-contar')) || 0;
        var pre = el.getAttribute('data-pre') || '', suf = el.getAttribute('data-suf') || '';
        if (reducido) { el.textContent = pre + fin.toLocaleString('es-CL') + suf; return; }
        var t0 = null, dur = 1600;
        function paso(t) {
          if (!t0) t0 = t;
          var p = Math.min(1, (t - t0) / dur), v = Math.round(fin * (1 - Math.pow(1 - p, 3)));
          el.textContent = pre + v.toLocaleString('es-CL') + suf;
          if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initAntesDespues() {
    document.querySelectorAll('.sm-ad').forEach(function (box) {
      if (box.dataset.smListo) return;
      box.dataset.smListo = '1';
      var activo = false;
      function mover(x) {
        var r = box.getBoundingClientRect();
        var p = Math.max(0, Math.min(100, ((x - r.left) / r.width) * 100));
        box.style.setProperty('--sm-pos', p + '%');
      }
      box.addEventListener('pointerdown', function (e) { activo = true; mover(e.clientX); box.setPointerCapture(e.pointerId); });
      box.addEventListener('pointermove', function (e) { if (activo) mover(e.clientX); });
      box.addEventListener('pointerup', function () { activo = false; });
      box.addEventListener('pointercancel', function () { activo = false; });
      box.addEventListener('keydown', function (e) {
        var actual = parseFloat(getComputedStyle(box).getPropertyValue('--sm-pos')) || 50;
        if (e.key === 'ArrowLeft') box.style.setProperty('--sm-pos', Math.max(0, actual - 5) + '%');
        if (e.key === 'ArrowRight') box.style.setProperty('--sm-pos', Math.min(100, actual + 5) + '%');
      });
    });
  }

  // Galería deslizable: el dedo (o la rueda) mueve las fotos; puntos, miniaturas y flechas siguen a la foto visible.
  function initGaleria() {
    document.querySelectorAll('[data-sm-galeria]').forEach(function (g) {
      var pista = g.querySelector('[data-sm-pista]');
      if (!pista) return;
      var slides = pista.children;
      var puntos = g.querySelectorAll('.sm-galeria__puntos span');
      var minis = g.querySelectorAll('[data-sm-ir]');
      var ant = g.querySelector('[data-sm-ant]');
      var sig = g.querySelector('[data-sm-sig]');
      var ultimo = slides.length - 1;

      function actual() {
        if (pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 4) return ultimo;
        var paso = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : pista.clientWidth;
        return Math.max(0, Math.min(ultimo, Math.round(pista.scrollLeft / paso)));
      }
      function marcar() {
        var i = actual();
        puntos.forEach(function (p, k) { p.classList.toggle('is-activo', k === i); });
        minis.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        if (ant) ant.disabled = i === 0;
        if (sig) sig.disabled = i === ultimo;
      }
      function ir(i) {
        i = Math.max(0, Math.min(ultimo, i));
        pista.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      }

      var pendiente = false;
      pista.addEventListener('scroll', function () {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(function () { pendiente = false; marcar(); });
      }, { passive: true });
      minis.forEach(function (b) { b.addEventListener('click', function () { ir(parseInt(b.getAttribute('data-sm-ir'), 10)); }); });
      if (ant) ant.addEventListener('click', function () { ir(actual() - 1); });
      if (sig) sig.addEventListener('click', function () { ir(actual() + 1); });
      pista.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); ir(actual() - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); ir(actual() + 1); }
      });
      marcar();
    });
  }

  // Banners de portada: se deslizan con el dedo; puntos y flechas; cambian solos cada X s
  // (se detienen al tocar, al pasar el mouse o si la pestaña no está a la vista).
  function initBanners() {
    document.querySelectorAll('[data-sm-banners]').forEach(function (s) {
      if (s.getAttribute('data-sm-listo')) return;
      s.setAttribute('data-sm-listo', '1');
      var pista = s.querySelector('[data-sm-pista]');
      if (!pista) return;
      var slides = pista.children;
      var ultimo = slides.length - 1;
      var puntos = s.querySelectorAll('[data-sm-ir]');
      var auto = parseInt(s.getAttribute('data-sm-auto'), 10) || 0;
      var pausa = false, reloj = null;

      function actual() { return Math.max(0, Math.min(ultimo, Math.round(pista.scrollLeft / (pista.clientWidth || 1)))); }
      function marcar() {
        var i = actual();
        puntos.forEach(function (p, k) { p.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }
      function ir(i) {
        if (i > ultimo) i = 0;
        if (i < 0) i = ultimo;
        var destino = i * pista.clientWidth;
        pista.scrollTo({ left: destino, behavior: reducido ? 'auto' : 'smooth' });
        // Respaldo: si el desplazamiento suave no llega (algunos navegadores), saltar directo
        setTimeout(function () { if (Math.abs(pista.scrollLeft - destino) > 4) pista.scrollTo({ left: destino }); }, 900);
      }
      function parar() { pausa = true; }

      var pendiente = false;
      pista.addEventListener('scroll', function () {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(function () { pendiente = false; marcar(); });
      }, { passive: true });
      puntos.forEach(function (b) { b.addEventListener('click', function () { parar(); ir(parseInt(b.getAttribute('data-sm-ir'), 10)); }); });
      var ant = s.querySelector('[data-sm-ant]'), sig = s.querySelector('[data-sm-sig]');
      if (ant) ant.addEventListener('click', function () { parar(); ir(actual() - 1); });
      if (sig) sig.addEventListener('click', function () { parar(); ir(actual() + 1); });
      pista.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); parar(); ir(actual() - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); parar(); ir(actual() + 1); }
      });
      ['pointerdown', 'touchstart', 'focusin', 'wheel'].forEach(function (ev) { s.addEventListener(ev, parar, { passive: true }); });
      s.addEventListener('mouseenter', function () { pausa = true; });
      s.addEventListener('mouseleave', function () { if (!s.contains(document.activeElement)) pausa = false; });

      if (auto > 0 && ultimo > 0 && !reducido) {
        reloj = setInterval(function () {
          if (!document.body.contains(s)) { clearInterval(reloj); return; }
          if (pausa || document.hidden) return;
          ir(actual() + 1);
        }, auto * 1000);
      }
      // En el editor de Shopify: al elegir un banner, mostrarlo y no avanzar solo
      document.addEventListener('shopify:block:select', function (e) {
        if (!s.contains(e.target)) return;
        parar();
        var i = Array.prototype.indexOf.call(slides, e.target);
        if (i > -1) pista.scrollTo({ left: i * pista.clientWidth });
      });
      marcar();
    });
  }

  function initBarra() {
    var barra = document.querySelector('.sm-barra');
    var form = document.querySelector('.sm-compra__form');
    if (!barra || !form) return;
    var io = new IntersectionObserver(function (e) {
      barra.classList.toggle('sm-visible', !e[0].isIntersecting);
    });
    io.observe(form);
  }

  function initCuentaAtras() {
    document.querySelectorAll('[data-sm-corte]').forEach(function (el) {
      var hora = parseInt(el.getAttribute('data-sm-corte'), 10);
      function pintar() {
        var ahora = new Date(), fin = new Date();
        fin.setHours(hora, 0, 0, 0);
        if (fin <= ahora) fin.setDate(fin.getDate() + 1);
        var s = Math.floor((fin - ahora) / 1000);
        var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), ss = s % 60;
        el.textContent = String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(ss).padStart(2, '0');
      }
      pintar();
      setInterval(pintar, 1000);
    });
  }

  function initFechas() {
    var dias = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
    var meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
    function sumarHabiles(fecha, n) {
      var d = new Date(fecha);
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
      return d;
    }
    function fmt(d) { return dias[d.getDay()] + ' ' + d.getDate() + ' ' + meses[d.getMonth()]; }
    document.querySelectorAll('[data-sm-fecha]').forEach(function (el) {
      var hoy = new Date();
      var partes = el.getAttribute('data-sm-fecha').split('-');
      var a = sumarHabiles(hoy, parseInt(partes[0], 10) || 0);
      if (partes.length > 1) {
        var b = sumarHabiles(hoy, parseInt(partes[1], 10) || 0);
        el.textContent = fmt(a) + ' – ' + fmt(b);
      } else {
        el.textContent = parseInt(partes[0], 10) === 0 ? 'Hoy' : fmt(a);
      }
    });
  }

  // Packs: al tocar uno se marca y se abre el pedido (el mismo botón de compra de la página)
  function initPacks() {
    document.querySelectorAll('[data-sm-pack]').forEach(function (b) {
      if (b.dataset.smListo) return;
      b.dataset.smListo = '1';
      b.addEventListener('click', function () {
        b.parentNode.querySelectorAll('[data-sm-pack]').forEach(function (x) { x.classList.toggle('is-destacado', x === b); });
        abrirPedido();
      });
    });
  }

  // Releasit: su botón (#rsi_buy_now_button) es el botón de compra de la página (el nuestro se oculta
  // con CSS cuando está). Los packs y la barra fija lo abren; si Releasit aún no carga (celulares lentos)
  // se espera hasta 6 s, y solo si nunca aparece se usa el pedido normal de Shopify.
  // 06-10: Releasit pone el mismo id también en el carrito lateral (vacío) y en su botón flotante.
  // Hay que usar el del formulario del producto: el del carrito abre el formulario gris, sin producto ni ofertas.
  function botonReleasit() {
    var form = document.getElementById('sm-form-producto');
    var propio = form && form.querySelector('#rsi_buy_now_button');
    if (propio) return propio;
    var todos = document.querySelectorAll('#rsi_buy_now_button');
    for (var i = 0; i < todos.length; i++) {
      if (!todos[i].closest('cart-drawer, #CartDrawer, .cart-drawer, #cart-wrapper')) return todos[i];
    }
    return null;
  }
  function abrirPedido() {
    var form = document.getElementById('sm-form-producto');
    var intentos = 0;
    (function probar() {
      var rsi = botonReleasit();
      if (rsi) return rsi.click();
      if (++intentos <= 30) return setTimeout(probar, 200);
      var boton = form && form.querySelector('[data-sm-boton]');
      if (boton && !boton.disabled) { form.dataset.smNormal = '1'; boton.click(); }
    })();
  }
  function initReleasit() {
    var form = document.getElementById('sm-form-producto');
    if (!form) return;
    // Los botones "Pedir ahora" de más abajo en la página abren el pedido directo, sin subir.
    document.querySelectorAll('a[href="#sm-comprar"]').forEach(function (a) {
      if (a.dataset.smRsi) return;
      a.dataset.smRsi = '1';
      a.addEventListener('click', function (e) { e.preventDefault(); abrirPedido(); });
    });
    if (form.dataset.smRsi) return;
    form.dataset.smRsi = '1';
    form.addEventListener('submit', function (e) {
      if (form.dataset.smNormal || (e.submitter && e.submitter.id === 'rsi_buy_now_button')) return;
      e.preventDefault();
      abrirPedido();
    }, true);
  }

  function init() {
    initReveal(); initParallax(); initCifras(); initAntesDespues();
    initGaleria(); initBanners(); initBarra(); initCuentaAtras(); initFechas(); initPacks(); initReleasit();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
